import {
  pushTutosMock,
  titreDescriptionMock,
  titreTexteCtaImageMock,
  titreTexteInfoMock,
  videoYoutubeMock,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  titreDescriptionMock(),
  videoYoutubeMock,
  titreTexteInfoMock,
  pushTutosMock,
  titreTexteCtaImageMock('gray'),
];

export const detailTutoMock: SlugPage = {
  ...pageBase({
    title: 'Je prépare la pose de ma cuisine équipée',
    type: 'article',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
